import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import MotivoPerdaProvider from "./MotivoPerdaContext";
import PesquisarMotivoPerda from "./Events/PesquisarMotivoPerda";
import FormularioMotivoPerda from "./Events/FormularioMotivoPerda";

const Index = () => {
  let match = useRouteMatch();
  return (
    <MotivoPerdaProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarMotivoPerda}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioMotivoPerda}
          />
        </Switch>
      </div>
    </MotivoPerdaProvider>
  );
};

export default Index;
